module.exports = __webpack_public_path__ + "img/jinn.17daa42d.png";